/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "arrow-left-2539237e--sprite",
  "use": "arrow-left-2539237e--sprite-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"arrow-left-2539237e--sprite\"><g transform=\"translate(36 36) rotate(180)\"><g transform=\"translate(-588 -1913)\"><g transform=\"translate(588 1913)\" fill=\"#fff\" stroke=\"#707070\" stroke-width=\"1\" opacity=\"0\"><rect width=\"36\" height=\"36\" stroke=\"none\" /><rect x=\"0.5\" y=\"0.5\" width=\"35\" height=\"35\" fill=\"none\" /></g></g><g transform=\"translate(-854.42 198.578)\"><path d=\"M879.62-180.337l-4.95,4.95a1.024,1.024,0,0,1-.71.29,1.024,1.024,0,0,1-.71-.29,1.008,1.008,0,0,1,0-1.42l2.58-2.57h-9.41a1,1,0,0,1-1-1,1,1,0,0,1,1-1h9.33l-2.5-2.5a1,1,0,0,1,0-1.41,1.008,1.008,0,0,1,1.42,0Z\" fill=\"currentColor\" /></g></g></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
